var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-description',{staticClass:"bar-description",attrs:{"path":[
      { label: _vm.$t('data.sidebar_mes_occupations'), route: 'occupations' },
      { label: _vm.$t('data.locations_mes_habitants'), route: 'habitants' },
    ]}}),(_vm.path == '')?_c('Habitants'):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }